import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted } from "vue";
import { useAuthStore } from "@/store/auth/login";
import {
  useCategoryCostsStore,
  CategoryCost,
} from "@/store/expenses/category_costs";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import TopCoefficientsPanel from "@/entities/expenses/coefficients/panels/TopCoefficientsPanel.vue";
import CoefficientsTable from "@/entities/expenses/coefficients/CoefficientsTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoefficientsPage',
  setup(__props) {

const authStore = useAuthStore();
const categoryCostsStore = useCategoryCostsStore();
const isLoading = ref(false);
const originalCoefficients = ref<CategoryCost[]>([]);
const coefficients = ref<CategoryCost[]>([]);

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["expenses:edit"]);
});

const hasChanges = computed(() => {
  if (originalCoefficients.value.length !== coefficients.value.length) {
    return true;
  }
  return originalCoefficients.value.some((original, index) => {
    const current = coefficients.value[index];
    return original.level !== current.level || original.cost !== current.cost;
  });
});

onMounted(() => {
  loadCoefficients();
});

const loadCoefficients = () => {
  isLoading.value = true;
  categoryCostsStore
    .getCategoryCosts()
    .then(() => {
      coefficients.value = JSON.parse(
        JSON.stringify(categoryCostsStore.categoryCosts)
      );
      originalCoefficients.value = JSON.parse(
        JSON.stringify(categoryCostsStore.categoryCosts)
      );
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const onCoefficientChange = (item: CategoryCost) => {
  const index = coefficients.value.findIndex((c) => c.level === item.level);
  if (index !== -1) {
    coefficients.value[index] = { ...item };
  }
};

const saveCoefficients = () => {
  isLoading.value = true;
  categoryCostsStore
    .updateCategoryCosts(coefficients.value)
    .then(() => {
      originalCoefficients.value = JSON.parse(
        JSON.stringify(coefficients.value)
      );
    })
    .finally(() => {
      isLoading.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(TopCoefficientsPanel, {
            isLoading: isLoading.value,
            "has-changes": hasChanges.value,
            onSave: saveCoefficients
          }, null, 8, ["isLoading", "has-changes"]),
          _createElementVNode("div", {
            id: "table-container",
            class: _normalizeClass(["table-container flex flex-col", [coefficients.value.length == 0 ? 'empty' : 'filled']])
          }, [
            _createVNode(CoefficientsTable, {
              coefficients: coefficients.value,
              isLoading: isLoading.value,
              onUpdateCoefficient: onCoefficientChange
            }, null, 8, ["coefficients", "isLoading"])
          ], 2)
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})